<script>
  import { createCommentVNode } from 'vue';
  export default {
    name: 'AwHook',
    emits: [
      'mounted',
    ],
    setup (_, { emit }) {
      onMounted(() => {
        emit('mounted');
      });
      let nodeCache = undefined;
      return () => nodeCache || (nodeCache = createCommentVNode('AwHook'));
    },
  };
</script>
